"use client";
/* eslint-disable @next/next/no-img-element */
import Link from "next/link";

import { MINIO_URL } from "@/lib/constant";
import { FaFacebook } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { TfiYoutube } from "react-icons/tfi";
import { FaSquareInstagram } from "react-icons/fa6";
import Image from "next/image";

export default function Footer() {
  return (
    <div className="flex flex-col sm:flex-row px-10 py-8 bg-[#235390] text-white">
      <div className="w-full md:w-1/4 ">
        {/* Content of the first part */}
        <div className="mb-20 ">
          <Image
            className="small-footer-logo"
            src={`${MINIO_URL}/images/corpu-white.png`}
            width={220}
            height={100}
            alt="logo"
          />
          <div className="mt-4">
            <p className="text-xs text-white ">
              Hak Cipta Badan Pendidikan dan Pelatihan Keuangan
            </p>
            <p className="text-xs text-white ">
              Kementerian Keuangan Republik Indonesia
            </p>
            <p className="text-xs text-white ">
              Manajemen Situs Kemenkeu Learning Center
            </p>
            <p className="text-xs text-white ">
              Jl. Purnawarman No 99 Kebayoran Baru, Jakarta{" "}
            </p>
            <p className="text-xs text-white ">Selatan Telp: 021-29054300</p>
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/4 ">
        {" "}
        <div className="mb-10 text-white">
          <p className="text-lg font-bold ">KLC</p>
          <Link href="https://klc2.kemenkeu.go.id/listcourse" passHref>
            <p className="has-text-light">Pusat Pelatihan</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/kms" passHref>
            <p className="has-text-light">Pusat Pengetahuan</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/help-desk/home" passHref>
            <p className="has-text-light">Pusat Bantuan</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/sertifikasi" passHref>
            <p className="has-text-light">Sertifikasi</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/cat" passHref>
            <p className="has-text-light">CAT</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/kspp" passHref>
            <p className="has-text-light">KSPP</p>
          </Link>
          <Link href="https://klc2.kemenkeu.go.id/sipp" passHref>
            <p className="has-text-light">SIPP</p>
          </Link>

          <p className="mt-5 mb-1 font-bold">Bantuan dan Panduan</p>
          <Link
            href="/help-desk/manual-category/a1d61a61-e989-47f8-8c9f-2c4746831105"
            passHref
          >
            <p className="has-text-light">Panduan Pengguna</p>
          </Link>
          <Link href="/help-desk/faq-category/null" passHref>
            <p className="has-text-light">FAQ</p>
          </Link>
          <Link href="/help-desk/contact-us" passHref>
            <p className="has-text-light">Halo BPPK</p>
          </Link>
          <Link href="/help-desk/privacy-policy" passHref>
            <p className="has-text-light">Kebijakan Privasi</p>
          </Link>
        </div>
      </div>

      <div className="w-full mb-10 md:w-1/4">
        {/* Content of the third part */}{" "}
        <p className="text-lg font-bold text-white">Ikuti Kami</p>
        <div className="">
          <Link
            href="https://www.facebook.com/bppk.kemenkeu/"
            target="_blank"
            passHref
            className="flex gap-x-2"
          >
            <FaFacebook className="self-center" />

            <p className="text-white ">bppk.kemenkeu</p>
          </Link>
        </div>
        <div className="">
          <Link
            href="https://twitter.com/bppkkemenkeu"
            target="_blank"
            passHref
            className="flex gap-x-2"
          >
            <FaTwitter className="self-center" />

            <p className="text-white ">@bppkkemenkeu</p>
          </Link>
        </div>
        <div className="">
          <Link
            href="https://www.youtube.com/channel/UCDBqV8WfMOK2pwHQZvONb7g"
            target="_blank"
            passHref
            className="flex gap-x-2"
          >
            <TfiYoutube className="self-center" />

            <p className="text-white ">BPPK Kemenkeu RI</p>
          </Link>
        </div>
        <div className="">
          <Link
            href="https://www.instagram.com/bppkkemenkeu/"
            target="_blank"
            passHref
            className="flex gap-x-2"
          >
            <FaSquareInstagram className="self-center" />

            <p className="text-white ">bppkkemenkeu</p>
          </Link>
        </div>
      </div>

      <div className="w-full md:w-1/4 ">
        {/* Content of the fourth part */}

        <p className="text-sm font-bold text-white">
          Unduh Aplikasi KLC Mobile
        </p>
        <div className="flex flex-wrap mt-3">
          <div className="flex-grow ">
            <Link
              href="https://play.google.com/store/apps/details?id=id.go.kemenkeu.bppk.klcmobile"
              target="_blank"
              passHref
            >
              <Image
                src={`${MINIO_URL}/images/googleplay.png`}
                width={100}
                height={100}
                alt="google play"
              />
            </Link>
          </div>
          <div className="flex-grow ">
            <Link
              href="https://apps.apple.com/us/app/klc-mobile/id1543201006"
              target="_blank"
              passHref
            >
              <Image
                src={`${MINIO_URL}/images/appstore.png`}
                width={100}
                height={100}
                alt="app store"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
